var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SurveyResultComponent',{attrs:{"companyName":"Agence du numérique","reference":_vm.globalReferenceData,"surveySession":_vm.surveySessionData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }